import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { keyBy } from '../../../../helpers/common'
import classes from '../../../index.module.scss'
import { selectForm, setForeign, setProvince } from '../../store/slice'
import ListItem from './ListItem'

const SelectedItem = ({ countries, cities }) => {
  const dispatch = useDispatch()

  const form = useSelector(selectForm)

  const provinceId = form?.province
  const foreignId = form?.foreign

  const [countryById, setCountryById] = useState({})
  const [cityById, setCityById] = useState({})

  useEffect(() => {
    if (countries.length) {
      setCountryById(keyBy(countries, 'id'))
    }
  }, [countries])

  useEffect(() => {
    if (cities.length) {
      setCityById(keyBy(cities, 'id'))
    }
  }, [cities])

  const deleteItem = (action) => (itemId) => (idDelete) => {
    dispatch(action(itemId.filter((id) => id !== idDelete)))
  }

  const deleteAll = () => {
    dispatch(setProvince([]))
    dispatch(setForeign([]))
  }

  const lengthSelected = provinceId.length + foreignId.length

  return (
    <div className={classes.selectedItem}>
      <div className="dFlex justifyContentBetween alignItemsCenter">
        <Element
          elementName="span"
          className={classes.title}
          style={{ color: '#3a414b' }}
        >
          {lengthSelected}
          {lengthSelected < 2 ? (
            <Translate value="settingPreferences.ITEM_SELECTED" />
          ) : (
            <Translate value="settingPreferences.ITEMS_SELECTED" />
          )}
        </Element>
        <Icon
          onClick={deleteAll}
          className={`icon-trash-fill ${classes.trash}`}
          style={{ color: '#9c9c9c', fontSize: 15 }}
        />
      </div>
      <div className={classes.tableItem}>
        <ScrollComponent>
          <ListItem
            title={<Translate value="settingPreferences.VIETNAM_PROVINCES" />}
            itemId={provinceId}
            itemById={cityById}
            deleteItem={deleteItem(setProvince)(provinceId)}
          />
          <ListItem
            title={<Translate value="settingPreferences.OTHER_COUNTRIES" />}
            itemId={foreignId}
            itemById={countryById}
            deleteItem={deleteItem(setForeign)(foreignId)}
          />
        </ScrollComponent>
      </div>
    </div>
  )
}

SelectedItem.propTypes = {
  countries: PropTypes.array.isRequired,
  cities: PropTypes.array.isRequired,
}

export default SelectedItem
